import { VertRadio as AntRadio } from '@vertem-core/vertice-ds';

const Radio=  AntRadio;

export default Radio;
